import { render, staticRenderFns } from "./NewsItemLeft.vue?vue&type=template&id=0dcb7d94&scoped=true&"
import script from "./NewsItemLeft.vue?vue&type=script&lang=ts&"
export * from "./NewsItemLeft.vue?vue&type=script&lang=ts&"
import style0 from "./NewsItemLeft.vue?vue&type=style&index=0&id=0dcb7d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb7d94",
  null
  
)

export default component.exports